export default (api) => ({
  get: (clientId) => api.get(`/credentials/${clientId}`),
})
